import * as i0 from '@angular/core';
import { Injectable, Optional, Inject } from '@angular/core';
import '@ff/material-controls/core/interfaces';
import { FF_MATERIAL_CONTROLS_CONFIG_TOKEN } from '@ff/material-controls/core/configs';
import '@angular/material/form-field';
import { FFObject } from '@ff/utils';
import '@ff/localization';
import '@ff/material-controls/core/types';

class FFMaterialControlsConfigService {
    constructor(config) {
        if (config == null) {
            console.error('Config is required for MaterialControls but it\'s not provided');
        }
        this._config = config;
    }
    getInputFloatLabel() {
        return this._config.floatLabel;
    }
    getInputAppearance() {
        return this._config.appearance;
    }
    getAutocompleteDebounceTime() {
        return this._config.autocompleteDebounceTime;
    }
    getTooltipDuration() {
        return this._config.tooltipDuration;
    }
    getTooltipThrottleTime() {
        return this._config.tooltipThrottleTime;
    }
    getFilterServiceConfig() {
        return this._config.filtersConfig;
    }
}
FFMaterialControlsConfigService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FFMaterialControlsConfigService, deps: [{ token: FF_MATERIAL_CONTROLS_CONFIG_TOKEN, optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
FFMaterialControlsConfigService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FFMaterialControlsConfigService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FFMaterialControlsConfigService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Optional
                    }, {
                        type: Inject,
                        args: [FF_MATERIAL_CONTROLS_CONFIG_TOKEN]
                    }] }];
    } });

class FFFiltersService {
    constructor(_configService) {
        this._configService = _configService;
        this.preventInputFilters = [
            { type: 'numeric', value: '[^0-9.]', title: '' },
            { type: 'alphaSpace', value: '[^a-zA-Z \-\]*', title: '' },
            { type: 'alphaNumeric', value: '[^a-zA-Z 0-9\-]*', title: '' },
            { type: 'alphaNumericNoSpace', value: '[^a-zA-Z0-9]*', title: '' },
            { type: 'alphaNumericSpace', value: '[^a-zA-Z0-9 ]*', title: '' },
            { type: 'alphaNumericSymbols', value: '[^a-zA-Z 0-9\- _"\'\[:#${}()%.,\\\]\!&\*\+\/;\?@\^\|\~]*', title: '' },
            { type: 'alphaNumericDashSpace', value: '[^-a-zA-Z0-9 ]*', title: '' },
            { type: 'alphaNumericDashSpaceCommaSlash', value: '[^-a-zA-Z0-9,\/ ]*', title: '' },
            { type: 'alphaCyrillicNumeric', value: '[^-a-zA-Z0-9а-яА-Я]*', title: '' },
            { type: 'email', value: '[^a-zA-Z_+~ 0-9\\- / @ .]*', title: '' },
            { type: 'cityStreetBuilding', value: '[^-a-zA-Z0-9 # " : . , \' / /\\\\]*', title: '' },
            { type: 'names', value: '[^-a-zA-Z \']*', title: '' }
        ];
        this._fillPreventInputFilters();
    }
    _fillPreventInputFilters() {
        const filtersConfig = this._configService.getFilterServiceConfig();
        if (filtersConfig == null || FFObject.keys(filtersConfig).length === 0) {
            console.error('Filters service config is not provided. It\'s necessary to display tooltips correctly');
            return;
        }
        this.preventInputFilters = this.preventInputFilters.map(item => { var _a; return (Object.assign(Object.assign({}, item), { title: (_a = filtersConfig[item.type]) !== null && _a !== void 0 ? _a : item.title })); });
    }
}
FFFiltersService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FFFiltersService, deps: [{ token: FFMaterialControlsConfigService }], target: i0.ɵɵFactoryTarget.Injectable });
FFFiltersService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FFFiltersService, providedIn: `root` });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FFFiltersService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: `root`,
                }]
        }], ctorParameters: function () { return [{ type: FFMaterialControlsConfigService }]; } });

class FFCountryFlagsService {
    constructor() { }
    getFlagClass(iso2Code, size) {
        const flagClases = 'flag-icon-circle flag-icon';
        let flagSizeClass = '';
        switch (size) {
            case 'extra-small':
                flagSizeClass = 'flag-icon-circle-xs';
                break;
            case 'small':
                flagSizeClass = 'flag-icon-circle-sm';
                break;
            case 'medium':
                flagSizeClass = 'flag-icon-circle-md';
                break;
            case 'large':
                flagSizeClass = 'flag-icon-circle-lg';
                break;
            case 'extra-large':
                flagSizeClass = 'flag-icon-circle-xl';
                break;
            case 'extra-extra-large':
                flagSizeClass = 'flag-icon-circle-xxl';
                break;
            default:
                flagSizeClass = '';
        }
        if (iso2Code == null) {
            return `${flagClases} flag-icon-unknown`;
        }
        if (typeof iso2Code !== 'string') {
            return `${flagClases} flag-icon-${iso2Code.id.slice(3, 5).toString()} ${flagSizeClass}`;
        }
        return `${flagClases} flag-icon-${iso2Code.toLowerCase()} ${flagSizeClass}`;
    }
}
FFCountryFlagsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FFCountryFlagsService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
FFCountryFlagsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FFCountryFlagsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FFCountryFlagsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

/**
 * Generated bundle index. Do not edit.
 */

export { FFCountryFlagsService, FFFiltersService, FFMaterialControlsConfigService };
